export const SERVICE_OPTIONS = [
  { value: "εξοικονομώ", label: "Εξοικονομώ", shortLabel: "Εξοικονομώ" },
  { value: "αντλίεςΘερμότητας", label: "Αντλίες Θερμότητας", shortLabel: "Αντλίες" },
  { value: "φωτοβολταϊκά", label: "Φωτοβολταϊκά", shortLabel: "Φ/Β" },
  { value: "κλιματιστικά", label: "Κλιματιστικά", shortLabel: "Κλιματιστικά" },
  { value: "φυσικόΑέριο", label: "Φυσικό Αέριο", shortLabel: "Φυσικό Αέριο" },
  { value: "ηλιακά", label: "Ηλιακά Συστήματα", shortLabel: "Ηλιακά" },
  { value: "ανακαινίζωΕνεργειακά", label: "Ανακαινίζω - Ενεργειακά συστήματα", shortLabel: "Ανακαινίζω · Ενεργειακά" },
  { value: "ανακαινίζωΠλήρηςΑνακαίνιση", label: "Ανακαινίζω - Πλήρης ανακαίνιση", shortLabel: "Ανακαινίζω · Ανακαίνιση" },
  { value: "άλλο", label: "Άλλο", shortLabel: "Άλλο" },
] as const;

export type ServiceType = (typeof SERVICE_OPTIONS)[number]["value"];

export const SERVICE_LABELS: Record<ServiceType, string> = Object.fromEntries(
  SERVICE_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<ServiceType, string>;

export const SERVICE_SHORT_LABELS: Record<ServiceType, string> = Object.fromEntries(
  SERVICE_OPTIONS.map(({ value, shortLabel }) => [value, shortLabel]),
) as Record<ServiceType, string>;

export const serviceLabel = (service: string, short = false): string => {
  const match = SERVICE_OPTIONS.find((option) => option.value === service);
  return match ? (short ? match.shortLabel : match.label) : service;
};

export const isRenovationProgramService = (service: string): boolean =>
  service === "ανακαινίζωΕνεργειακά" || service === "ανακαινίζωΠλήρηςΑνακαίνιση";
